// @ts-nocheck
import React from "react";
import { FormikProps } from "formik";
import { RemoveIcon } from "../../../Wrapper";
import { currency } from "src/constants/payments";
import { Field } from "src/components/Forms/Field";
import { FormikSelect } from "src/components/Forms/Select";

interface Props {
  formProps: FormikProps<any>;
  clearFilterKey: (key: string) => void;
}

const Public: React.FC<Props> = ({ formProps, clearFilterKey }) => {
  let isVisible = false;

  if (formProps?.values?.paymentCurrency) {
    isVisible = true;
  }

  return (
    <Field
      label="Currency:"
      mb={20}
      color="black"
      isBeside={true}
      extra={
        isVisible && (
          <RemoveIcon
            type="close-circle"
            onClick={() => {
              formProps?.setFieldValue("paymentCurrency", undefined);
              clearFilterKey("paymentCurrency");
            }}
            style={{ marginTop: "-1px", marginLeft: "10px" }}
          />
        )
      }
      id="countryBreakdown"
    >
      <FormikSelect
        name="paymentCurrency"
        data={currency}
        local
        borderRadius={3}
        borderColor="grey5"
        size="small"
        minHeight={35}
      />
    </Field>
  );
};

export default Public;
